import EodIndexBoardPage from './EodIndexBoardPage';

/** Home dashboard — multi-index EOD board (NSE: NIFTY/BN/FN · BSE: SENSEX/BANKEX). */
export default function DashboardPage() {
  return <EodIndexBoardPage />;
}